import { useI18n } from '../../i18n';
import { PeopleIcon } from '../shared/Icons';

interface Props {
  /** The age groups the tournament takes; null or empty: every age group,
   *  and the component renders nothing (#532). */
  groups: string[] | null | undefined;
  /** `sm` on the tournament card, `md` in the header of the tournament page. */
  size?: 'sm' | 'md';
  className?: string;
  testId?: string;
}

/** #532 — the age groups of a limited tournament, as pills. A coach must see
 *  the limit at a glance on the card, before opening the tournament
 *  (operator, 2026-09-29). Indigo: the card uses the other colors for the
 *  type, the assignments and the livestream. */
export default function AgeGroupPills({ groups, size = 'sm', className = '', testId }: Props) {
  const { t } = useI18n();
  if (!groups?.length) return null;
  // The shape and the size of the type badge (operator, 2026-09-30): a
  // `badge`, 12 px and 20 px tall, on the card and on the page. `size`
  // changes only the icon.
  return (
    <div data-testid={testId} role="list" aria-label={t.tournament.ageGroupsTaken} title={t.tournament.ageGroupsTaken}
      className={`flex flex-wrap items-center gap-1 ${className}`}>
      <PeopleIcon className={`${size === 'md' ? 'w-4 h-4' : 'w-3.5 h-3.5'} text-indigo-500 shrink-0`} />
      {groups.map(code => (
        <span key={code} role="listitem"
          className="badge bg-indigo-100 font-semibold text-indigo-800">
          {code}
        </span>
      ))}
    </div>
  );
}
